module.exports = __webpack_public_path__ + "static/email-template-trial-ended-robolly-227939fd469707fccd47b4850e9cf164.png";